import { render, staticRenderFns } from "./HelloUser.vue?vue&type=template&id=c447b12c&scoped=true"
import script from "./HelloUser.vue?vue&type=script&lang=ts"
export * from "./HelloUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c447b12c",
  null
  
)

export default component.exports